import React from 'react';
import PropTypes from 'prop-types';

import { BreadcrumbsSchema, DeeplinkSchema } from 'components/Schema';
import PageHeader from 'components/PageHeader';
import PageContent from 'components/PageContent';
import LoadingPage from 'components/pages/status/LoadingPage';
import OfflinePage from 'components/pages/status/OfflinePage';
import ContentPageLayout from 'components/ContentPageLayout';

import { MIJN_JUKE_PAGE_TITLE, MY_JUKE_SLUG } from 'globalConst/const';
import { SCHEMA_MY_JUKE_DEEPLINK } from 'globalConst/schema-const';

import DynamicPage from 'components/pages/DynamicPage';
import FavoriteStationsCollection from './FavoriteStationsCollection';
import FavoritePodcastsCollection from './FavoritePodcastsCollection';

function MyJukePage({ isLoading, error, isOnline, isUserLoggedIn, hasDynamicPage, stations, podcasts }) {
  if (isLoading && !error) {
    return (
      <ContentPageLayout>
        <LoadingPage />
      </ContentPageLayout>
    );
  }

  if (!isUserLoggedIn && hasDynamicPage) {
    return <DynamicPage slug={MY_JUKE_SLUG} />;
  }

  if (!isOnline) {
    return <OfflinePage />;
  }

  return (
    <ContentPageLayout>
      <PageHeader title={MIJN_JUKE_PAGE_TITLE} />
      <BreadcrumbsSchema level2={MIJN_JUKE_PAGE_TITLE} />
      <DeeplinkSchema deeplinks={[{ link: SCHEMA_MY_JUKE_DEEPLINK }]} />
      <PageContent>
        <FavoriteStationsCollection isUserLoggedIn={isUserLoggedIn} stations={stations} />
        <FavoritePodcastsCollection isUserLoggedIn={isUserLoggedIn} podcasts={podcasts} />
      </PageContent>
    </ContentPageLayout>
  );
}

MyJukePage.propTypes = {
  isUserLoggedIn: PropTypes.bool.isRequired,
  stations: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
  error: PropTypes.object,
  isOnline: PropTypes.bool.isRequired,
  podcasts: PropTypes.array.isRequired,
  hasDynamicPage: PropTypes.bool,
};

MyJukePage.defaultProps = {
  error: {},
  hasDynamicPage: false,
};

export default MyJukePage;
